import { Component, ViewEncapsulation, Input, OnDestroy, NgZone } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { NotifierService } from '../../../shared/notifier/notifier.service';
import { Subscription } from 'rxjs/Subscription';
import { BudgetService } from '../../../services/budget.service';
import { IBudgetDetail } from '../new-budget.component';
import { NgForm } from '@angular/forms';
import * as uuid from 'uuid';
import { ListofvaluesService } from '../../../services/listofvalues.service';
import { ProviderService } from '../../../services/provider.service';
import { ListPriceService } from '../../../services/list-price.service';
@Component({
    selector: 'app-create-budget',
    templateUrl: 'createBudgetModal.component.html',
    styleUrls: ['./createBudgetModal.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [BudgetService, ListofvaluesService, ProviderService, ListPriceService]
})
export class CreateBudgetModalComponent implements OnDestroy {
    budgetItem: IBudgetDetail = {};
    modalTitle = '';
    buttonText = '';
    subscription: Subscription;
    action: string;
    ldvMoney: any;
    providers: any;
    client_no_comission = false;
    client_id: number;
    listPriceProducts: Array<IProductList> = [];
    listProductsObject: IProductList = {};
    constructor(public dialogRef: MatDialogRef<CreateBudgetModalComponent>,
        private listofvaluesService: ListofvaluesService,
        private notifierService: NotifierService,
        private providerService: ProviderService,
        private listPriceService: ListPriceService,
        private zone: NgZone) {

        this.providerService.listProviders().subscribe((result) => {
            this.providers = result;
            this.providers.sort(function(a, b){
                if(a.comercial_name < b.comercial_name) { return -1; }
                if(a.comercial_name > b.comercial_name) { return 1; }
                return 0;
            })
        });

        this.listofvaluesService.getLdvByCode('TBWA-MONEY').subscribe((result) => {
            this.ldvMoney = result;
        });

        this.handleNotify();
    }

    handleNotify() {
        this.subscription = this.notifierService.behaviorNotifierObject$.subscribe(
            message => {
                this.zone.run(() => {
                    this.action = message.action;
                    this.client_no_comission = message.object.client_no_comission;
                    // tslint:disable-next-line:triple-equals
                    if (message.action == 'edit' && message.model == 'budget') {
                        this.budgetItem = message.object.data;
                        this.buttonText = 'Actualizar';
                        this.modalTitle = 'Editar Detalle de Presupuesto';
                        // tslint:disable-next-line:triple-equals
                    } else if (message.action == 'register' && message.model == 'budget') {
                        this.budgetItem = message.object.data;
                        this.budgetItem.with_commission = false;
                        this.budgetItem.create_uuid = uuid.v4();
                        this.buttonText = 'Crear';
                        this.modalTitle = 'Crear Detalle de Presupuesto';
                    }
                    // console.log('message', message);
                    // console.log('message', message.object.client_id);
                    this.listPriceService.getPriceListProductByidClient(message.object.client_id).subscribe(
                        (result: Array<IProductList>) => {
                            this.listPriceProducts = [{}, ...result];
                        });
                });

            }
        );
    }

    update(form: NgForm) {
        if (form.valid) {
            if (this.budgetItem.provider_id) {
                const found = this.providers.find((item) => {
                    // tslint:disable-next-line:triple-equals
                    return item.id == this.budgetItem.provider_id;
                });
                this.budgetItem.provider_name = found.comercial_name;
            }
            if (this.budgetItem.id) {
                this.budgetItem.action_backend = 'U';
            } else {
                this.budgetItem.action_backend = 'C';
            }
            this.dialogRef.close(this.budgetItem);
        } else {
            this.notifierService.systemNotify({
                title: 'Ha ocurrido un error',
                message: 'Por favor complete los campos obligatorios',
                type: 'error'
            });
        }
    }

    create(form: NgForm) {
        if (form.valid) {
            if (this.budgetItem.provider_id) {
                const found = this.providers.find((item) => {
                    // tslint:disable-next-line:triple-equals
                    return item.id == this.budgetItem.provider_id;
                });
                this.budgetItem.provider_name = found.comercial_name;
            }
            this.budgetItem.action_backend = 'C';
            this.dialogRef.close(this.budgetItem);
        } else {
            this.notifierService.systemNotify({
                title: 'Ha ocurrido un error',
                message: 'Por favor complete los campos obligatorios',
                type: 'error'
            });
        }
    }

    close() {
        this.dialogRef.close();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    addProduct() {
        console.log(this.listProductsObject);
        this.budgetItem.description = this.listProductsObject.nombre_producto + ' - ' + this.listProductsObject.descripcion_producto;
        this.budgetItem.price = this.listProductsObject.price;
    }

    changeCosto() {
        if (this.budgetItem.cost_provider < 0){
            this.budgetItem.cost_provider = 0;
        }
    }

    changeCantidad() {
        if (this.budgetItem.quantity < 0){
            this.budgetItem.quantity = 0;
        }
        this.budgetItem.price = this.budgetItem.unit_price * this.budgetItem.quantity;
    }

    changePrecio() {
        if(this.budgetItem.unit_price < 0){
            this.budgetItem.unit_price = 0;
        }
        this.budgetItem.price = this.budgetItem.unit_price * this.budgetItem.quantity;
    }
}
export interface IProductList {
    id?: number;
    id_product?: number;
    id_list_price?: number;
    price?: number;
    tenant?: number;
    create_date?: Date;
    nombre_producto?: string;
    descripcion_producto?: string;
    unidad_producto?: string;
    habilitado?: number;
    codigo_producto?: string;
}



// WEBPACK FOOTER //
// ./src/app/system/budget/new-budget/createBudgetModal/createBudgetModal.component.ts